import { render } from "./calendarSvg.vue?vue&type=template&id=1a1813ae&ts=true"
import script from "./calendarSvg.vue?vue&type=script&lang=ts"
export * from "./calendarSvg.vue?vue&type=script&lang=ts"

import exportComponent from "/builds/sgumanea/ciena/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__